import React from 'react'
import CommonHeader from './CommonHeader';

/**
 * Header for the "Question and Answers View" of an expired exam: the shared
 * CommonHeader with a back button. No analysis links, since the exam expired.
 *
 * Props: onClick (sidebar toggle).
 */
function ExpiresExamHistoryNavbar({ onClick }) {
    return (
        <CommonHeader
            color="auto"
            tone="light"
            onToggleSidebar={onClick}
            back={true}
            backLabel="Go Back"
            title="Question and Answers View"
        />
    );
}

export default ExpiresExamHistoryNavbar;
